module.exports = __webpack_public_path__ + "img/336-75a1fc.png";